import React, { useEffect, useState } from "react";
import {
  Table,
  Divider,
  PageHeader,
  Button,
  Form,
  Select,
  Input,
  message,
  Modal,
  Segmented,
  Radio,
  Checkbox,
  DatePicker,
  Image,
} from "antd";
import {
  FlexRowContainer,
  FlexRowEndContainer,
  FlexRowQuarterContainer,
  FlexRowReverseContainer,
} from "../Common/Container.styles";

import { useNavigate } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";

import * as userAPI from "../../api/user";

import {
  dateToCompactString,
  dateToString,
  numberWithCommas,
} from "../../util/common";

import Pagination from "react-js-pagination";
import { Option } from "antd/lib/mentions";
import { useRecoilState } from "recoil";
import { searchItemState } from "../../states/atoms";
import TextArea from "antd/lib/input/TextArea";
import {deleteCertificates, editCertificates, getCertificates} from "../../api/user";
import * as commonAPI from "../../api/common";

export default function CertificateList() {
  const [searchItem, setSearchItem] = useRecoilState(searchItemState);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [current, setCurrent] = useState(
    Number(sessionStorage.getItem("page")) ?? 1
  );
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState("전체");

  const [startCreatedDate, setStartCreatedDate] = useState(null);
  const [endCreatedDate, setEndCreatedDate] = useState(null);

  const [showRefundModal, setShowRefundModal] = useState(false);

  const onChange = (page) => {
    setCurrent(page);
    sessionStorage.setItem("page", page);
  };

  const [form] = Form.useForm();

  const searchQuery = Form.useWatch("searchQuery", form);
  const searchKeyword = Form.useWatch("searchKeyword", form);
  const status = Form.useWatch("status", form);
  const bannering = Form.useWatch("bannering", form);
  const size = Form.useWatch("size", form);
  const isConfirm = Form.useWatch("isConfirm", form);

  const fetchItems = () => {
    const request = {
      page: current,
      size: size ?? 50,
      startCreatedDate,
      endCreatedDate,
      isConfirm
    };
    request[`${searchQuery}`] = searchKeyword;
    request[`${searchItem.searchQuery}`] = searchItem.searchKeyword;

    userAPI.getCertificates(request).then((res) => {
      if (res.data.linusCode === 1) {
        setTotal(res.data.page.count);
        setItems(res.data.data?.map((item) => {return {...item, key: item?.id}}))
        setLoading(false);
      } else {
        alert(res.data.data.msg);
      }
    });
  };

  const allConfirm = () => {
    let requests = selectedItems?.map((i) => {
      return userAPI.editCertificates({
        id: i.id,
        isConfirm: true,
      });
    });

    Promise.all(requests)
      .then((res) => {
        fetchItems();
        message.success("승인이 완료되었습니다.");
      })
      .catch((error) => {
        if (error?.response?.data?.data?.msg) {
          alert(error.response.data.data.msg);
        }
      });
  }

  const deleteAllCertificates = () => {
    let requests = selectedItems?.map((i) => {
      return userAPI.deleteCertificates({
        id: i.id,
      });
    });

    Promise.all(requests)
      .then((res) => {
        fetchItems();
        message.success("삭제가 완료되었습니다.");
      })
      .catch((error) => {
        if (error?.response?.data?.data?.msg) {
          alert(error.response.data.data.msg);
        }
      });
  }



  useEffect(() => {
    if (current !== 1) {
      setCurrent(1);
      return;
    }

    setLoading(true);
    fetchItems();
  }, [filter, startCreatedDate, endCreatedDate, status, bannering, size, isConfirm, searchItem]);

  useEffect(() => {
    setLoading(true);
    fetchItems();
  }, [current]);

  const onSearch = (e) => {
    if (!searchQuery) {
      message.error("검색조건을 선택해주세요.");
      return;
    }

    if (!searchKeyword) {
      message.error("검색 키워드를 입력해주세요.");
      return;
    }

    const newSearchItem = {
      ...searchItem,
      searchQuery: searchQuery,
      searchKeyword: searchKeyword,
    };
    setSearchItem(newSearchItem);

    setCurrent(1);
    sessionStorage.setItem("page", 1);

    setLoading(true);
    // fetchItems();
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedItems(selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled Banner",
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  // 주문번호, 닉네임, 가입채널, 가입년월일시, 최종로그인년월일시, 마케팅동의여부
  const columns = [
    { title: "ID", dataIndex: "id" },
    {
      title: "유저 이름/이메일",
      dataIndex: "user",
      render: (val) => {
        return (
          <div onClick={() => navigate(`/user/user/edit/${val?.id}`)}>{val?.name + '\n' + val?.email}</div>
        )
      }
    },
    {
      title: "수료과정",
      width: '40%',
      dataIndex: "certificateType",
      render: (val) => {
        return val?.name ?? '-'
      },
    },
    {
      title: "수료일",
      dataIndex: "date",
      render: (val) => {
        return val ? val?.split('T')[0] : '-'
      },
    },
    {
      title: "수료번호",
      width: '5%',
      dataIndex: "completeNumber",
      render: (val) => {
        return val ?? '-'
      },
    },
    {
      title: "자격번호",
      width: '5%',
      dataIndex: "certNumber",
      render: (val) => {
        return val ?? '-'
      },
    },
    // {
    //   title: "생성일",
    //   dataIndex: "createdDate",
    //   width: "10%",
    //   render: (val) => {
    //     return dateToString(val);
    //   },
    // },
    {
      title: "업데이트 시각",
      dataIndex: "updatedDate",
      width: "10%",
      render: (val) => {
        return dateToString(val);
      },
    },
    {
      title: '승인 처리',
      render: obj => {
        return (
          obj?.isConfirm ?
            <div>
             승인됨
              <Button
                danger
                onClick={e => {
                e.preventDefault()
                if (window.confirm('승인 취소처리 하시겠습니까?')) {
                  userAPI.editCertificates({
                    id: obj?.id,
                    isConfirm: false
                  }).then(res => {
                    fetchItems()
                  })
                }
              }}>
                승인 취소
              </Button>
            </div>
            :
          <Button onClick={e => {
            e.preventDefault()
            if (window.confirm('승인처리 하시겠습니까?')) {
              userAPI.editCertificates({
                id: obj?.id,
                isConfirm: true
              }).then(res => {
                fetchItems()
              })
            }
          }}>
            승인
          </Button>
        )
      }
    }
  ];

  const searchQueries = [
    {
      title: "유저 이름",
      dataIndex: "userName",
    },
    {
      title: "유저 이메일",
      dataIndex: "userEmail",
    },
    {
      title: "수료과정",
      dataIndex: "type",
    },
    {
      title: "수료일",
      dataIndex: "date",
    },
    {
      title: "수료번호",
      dataIndex: "completeNumber",
    },
    {
      title: "자격번호",
      dataIndex: "certNumber",
    },
    {
      title: "업데이트 시각",
      dataIndex: "updatedDate",
    },
  ];

  return (
    <div>
      <PageHeader
        className="site-page-header"
        title="구매자격 목록"
        subTitle={`총 ${total}개의 구매자격이 존재합니다.`}
      />
      <Form form={form} onFinish={onSearch}>
        <FlexRowContainer style={{ marginTop: "10px" }}>
          <FlexRowQuarterContainer>
            <Form.Item name="searchQuery" initialValue={searchItem.searchQuery}>
              <Select placeholder="검색조건">
                {searchQueries?.map((c) => {
                  return (
                    <Select.Option key={c.dataIndex} value={c.dataIndex}>
                      {c.title}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              name="searchKeyword"
              initialValue={searchItem.searchKeyword}
            >
              <Input placeholder="검색 키워드를 입력하세요" />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
              />
            </Form.Item>
          </FlexRowQuarterContainer>
        </FlexRowContainer>
        <FlexRowContainer style={{ marginTop: "10px" }}>
          <Form.Item name="isConfirm" style={{ width: "300px" }}>
            <Select placeholder="승인 여부">
              {[
                { label: "전체", value: null },
                { label: "승인됨", value: true },
                { label: "미승인", value: false },
              ].map((c) => {
                return (
                  <Select.Option key={c.label} value={c.value}>
                    {c.label}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        </FlexRowContainer>
      </Form>
      <FlexRowEndContainer>
        <Button
          style={{marginRight: 10}}
          onClick={e => {
            e.preventDefault()
            allConfirm()
          }}
        >
          일괄 승인 처리
        </Button>
        <Button
          danger
          onClick={e => {
            e.preventDefault()
            if (window.confirm('정말 선택된 항목을 모두 삭제 하시겠습니까?')) {
              deleteAllCertificates()
            }
          }}
        >
          일괄 삭제
        </Button>
      </FlexRowEndContainer>
      <Divider />
      <Table
        pagination={false}
        loading={loading}
        columns={columns}
        dataSource={items}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        // onRow={(record, rowIndex) => {
        //   return {
        //     onClick: (event) => {
        //       navigate(`/setting/banner/edit/${record.id}/`);
        //     }, // click row
        //     onDoubleClick: (event) => {}, // double click row
        //     onContextMenu: (event) => {}, // right button click row
        //     onMouseEnter: (event) => {}, // mouse enter row
        //     onMouseLeave: (event) => {}, // mouse leave row
        //   };
        // }}
      />
      <FlexRowEndContainer style={{ marginTop: "30px" }}>
        <Pagination
          activePage={current}
          itemsCountPerPage={size ?? 50}
          totalItemsCount={total}
          pageRangeDisplayed={10}
          onChange={onChange}
        />
      </FlexRowEndContainer>
    </div>
  );
}
